const getApplicationDecisionPath = (
    applicationId: string | number,
    useLegacyDecisionPage: boolean | undefined = true,
) => {
    if (useLegacyDecisionPage) {
        return `#!/application/${applicationId}/approval`
    }

    return `#/application/decision/${applicationId}`
}

export default getApplicationDecisionPath
